import styled from 'styled-components';

export const Wrapper = styled.div`
  border-top: 1px solid #222222;
  margin-top: 2em;
  min-height: 111px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: stretch;

  a {
    display: flex;
    min-height: 80px;

    .stoneco {
      align-self: center;

      @media (max-width: 768px) {
        display: none;
      }
    }
  }

  ul {
    list-style: none;
    display: flex;
    justify-items: flex-start;

    li {
      margin-right: 32px;
      display: flex;
      align-items: center;
      padding-top: 30px;

      a {
        transition: all 0.25s ease-in-out;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        text-decoration: none;

        .logo-description {
          font-family: 'Lato', sans-serif;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0.48px;
          color: ${({ theme }) => theme.colors.white};
          visibility: hidden;
          margin-top: 12px;
          transition: all 0.25s ease-in-out;
          opacity: 0;
          text-transform: uppercase;
        }
      }

      &:not(.selected):hover {
        border-top: 2px solid ${({ theme }) => theme.colors.green};
        margin-top: -2px;

        & a {
          transform: translateY(-10px);

          img {
            opacity: 1;
            filter: brightness(3);
          }

          .logo-description {
            transform: translateY(-5px);
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }

    .selected {
      border-top: 2px solid ${({ theme }) => theme.colors.green};
      margin-top: -2px;

      a {
        transform: translateY(-10px);

        img {
          opacity: 1;
        }

        .logo-description {
          transform: translateY(-5px);
          visibility: visible;
          opacity: 1;
        }
      }
    }

    a {
      img {
        width: 50px;
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Container = styled.div`
  width: 90%;
  max-width: 1328px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
`;

export const StoneCoBottomLink = styled.div`
  width: 80%;
  max-width: 1328px;
  margin: 40px auto 24px;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 1444px) {
    width: 90%;
  }
`;
